import { keyframes } from 'styled-components';

export default keyframes`
  50% {
    transform: translate(0, 20px);
  }
`;
